<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0">{{buildName}} {{ today | date:'y'}} @ {{ version }} </p>
        </div>
    </div>
</div>